import { Grid, Text, Flex, Alert } from '@builtbypixel/plasma';
import React from 'react';
import { useWatch } from 'react-hook-form';
import moment from 'moment';
import { Field } from '@builtbypixel/nucleus';

const Label = ({ children }) => (
    <Text
        fontWeight='semibold'
        opacity={0.6}
        textAlign='left'
        pr='50px'
        mb='5px'
    >
        {children}
    </Text>
);
const Value = ({ children }) => <Text mb='5px'>{children}</Text>;

const MosqueSubscription = () => {
    const subscription = useWatch({ name: 'subscription' });
    return (
        <Flex w='100%' direction='column'>
            <Text fontWeight='semibold' fontSize='1.2em' mb='5px'>
                Allow free access
            </Text>
            <Field component='switch' name='free_subscription' mb='50px'>
                <Alert status='warning'>
                    This will allow unlimited access for this Mosque. It will
                    also cancel any active subscriptions this Mosque currently
                    has.
                </Alert>
            </Field>
            <Text fontWeight='semibold' fontSize='1.2em' mb='20px'>
                Go Cardless Information
            </Text>
            <Grid templateColumns='250px 1fr' w='100%' mb='25px'>
                <Label>GC Bank Account ID</Label>
                <Value>{subscription?.gc_bank_account_id}</Value>
                <Label>GC Customer ID</Label>
                <Value>{subscription?.gc_customer_id}</Value>
                <Label>GC Subscription ID</Label>
                <Value>{subscription?.gc_subscription_id}</Value>
            </Grid>
            <Text fontWeight='semibold' fontSize='1.2em' mb='20px'>
                Payment Information
            </Text>
            <Grid templateColumns='250px 1fr' w='100%'>
                <Label>Subscription Started</Label>
                <Value>
                    {moment(subscription?.start_date).format('DD/MM/YYYY')}
                </Value>
                <Label>Next Payment Date</Label>
                <Value>
                    {moment(subscription?.next_payment_date).format(
                        'DD/MM/YYYY'
                    )}
                </Value>
                <Label>Payment Amount</Label>
                <Value>£{subscription?.price / 100} per month</Value>
            </Grid>
        </Flex>
    );
};

export default MosqueSubscription;
